import {
  ActivationStatuses,
  Address,
  Plan,
  SignUpStatuses,
} from '@smarty-nx/data'

export const getDeliveryAddressTitle = (
  index: number,
  total?: number
): string => {
  const numbersMapping: { [k: number]: string } = {
    1: 'Second',
    2: 'Third',
    3: 'Fourth',
    4: 'Fifth',
    5: 'Sixth',
    6: 'Seventh',
    7: 'Eighth',
  }

  return index === 0
    ? total && total > 1
      ? 'First delivery address'
      : 'Your address'
    : `${numbersMapping[index]} delivery address`
}

export const getAddressLabel = ({
  street_1,
  street_2,
  postal_code,
  town,
  country,
  company,
}: Address) =>
  [street_1, street_2, company, town, country, postal_code]
    .filter((field) => !!field)
    .join(', ')

export const getFamilyPlanPrice = (
  plan: Plan,
  additionalSimPrice: number,
  membersNumber: number
): number => plan.finalPrice?.value + (membersNumber - 1) * additionalSimPrice

const PreActivationStatuses = [
  ActivationStatuses.ACTIVATE_SIM,
  ActivationStatuses.ACTIVATION_FAILED,
  SignUpStatuses.SETUP,
  SignUpStatuses.PENDING,
  SignUpStatuses.COMPLETED,
] as const

export function isPreActivationStatus(
  status: string
): status is (typeof PreActivationStatuses)[number] {
  return PreActivationStatuses.some((s) => status === s)
}
